import React from 'react';
import {View} from 'react-native';
import {get} from 'lodash';

import FormattedNumber from '/component/base/FormattedNumber';
import Text from '/component/base/Text';
import {Reports} from '/constant/TestIDs';
import {withTranslation} from '/provider/TranslationProvider';
import {capGQV} from '/util/attribute.util';

import {styles} from './GqvOe.style';

interface OrderingEntities {
  currentCount: number;
  target: number;
}

interface GqvOeItem {
  gqv: string;
  orderingEntities: OrderingEntities;
}

interface GqvOeProps {
  tt: (key: string, defaultValue: string) => string;
  item: GqvOeItem | null;
}

export const GqvOe: React.FC<GqvOeProps> = ({
  tt = withTranslation.ttDefaultProp,
  item = null,
}: GqvOeProps) => {
  const gqv = get(item, 'gqv', '');
  const currentCount = get(item, 'orderingEntities.currentCount', '');
  const target = get(item, 'orderingEntities.target', '');

  return (
    <View style={styles.attributes}>
      <Text variant="button" emphasis="medium">
        {tt('orderingEntities', 'Ordering Entities')}
      </Text>
      <Text
        emphasis="medium"
        testID={Reports.reportCoachOe}>{` ${currentCount}/${target} · `}</Text>
      <Text variant="button" emphasis="medium">
        {tt('gqv', 'GQV')}{' '}
      </Text>
      <FormattedNumber
        // @ts-expect-error TS(2322): Type '{ value: any; textEmphasis: string; boldText... Remove this comment to see the full error message
        value={capGQV(gqv)}
        textEmphasis="medium"
        boldText={false}
        truncate
        testID={Reports.reportCoachGQV}
      />
    </View>
  );
};

export default withTranslation('report.record.gqvOe')(GqvOe);
